import { useTranslation } from 'react-i18next';

import type { AppLocale } from '@/shared/lib';

import { NOINDEX_PAGES, PAGE_SCHEMAS, type SeoPage } from './pages';
import { Seo } from './Seo';

/** Head tags for a registry page: copy from the seo namespace, data from PAGE_SCHEMAS. */
export const PageSeo = ({ page }: { page: SeoPage }) => {
  // Structured data quotes plan names and FAQ copy from the marketing
  // namespace; pages without it must not download that namespace.
  const { t, i18n } = useTranslation(PAGE_SCHEMAS[page] ? ['seo', 'marketing'] : ['seo']);
  const locale = i18n.language as AppLocale;

  return (
    <Seo
      title={t(`seo:pages.${page}.title`)}
      description={t(`seo:pages.${page}.description`)}
      noindex={NOINDEX_PAGES.has(page)}
      jsonLd={PAGE_SCHEMAS[page]?.({ t, locale }) ?? []}
    />
  );
};
